<template>
  <div class="main-container rounded-t-3xl wrap auth h-full w-full">
    <LocaleSwitcherOnRight/>
    <h2 class="text-align-center mb-8">{{ $t('signUp.title') }}</h2>
    <p class="text-align-center mb-8">{{ $t('signUp.discover') }}</p>
    <validation-observer tag="form" ref="formInput" v-slot="{valid}" @submit.prevent="handleForm">
      <uni-input
          :label="$t('validation.placeholders.email')"
          id="input-test"
          type="email"
          :placeholder="$t('validation.placeholders.email')"
          v-model="email"
          rules="required|email|emailExists"
      />
      <uni-input-password
          :label="$t('validation.placeholders.password')"
          id="password"
          :placeholder="$t('validation.placeholders.password')"
          vid="password"
          v-model="pwd"
          :helperMessage="$t('validation.errors.password')"
          rules="required|passwordTest"/>
      <UniInputPassword
          :label="$t('validation.placeholders.confirmPassword')"
          id="input-password-confirm"
          :placeholder="$t('validation.placeholders.confirmPassword')"
          v-model="pwdConfirm"
          :helperMessage="$t('validation.errors.passwordConfirm')"
          rules="required|confirmed:password|passwordTest"
          min="6"
      />
      <uni-checkbox value="teacher" v-model="teacher"
                    :label="$t('signUp.teacher')" class="mb-4"/>
      <h3 class="text-align-center">{{ message }}</h3>
      <UniSectionMessage v-if="googleAlreadyExists" type="warning" :title="$t('signUp.errors.google.title')"
                         :description="$t('signUp.errors.google.content')"
      />
      <UniSectionMessage v-if="facebookAlreadyExists" type="warning" :title="$t('signUp.errors.facebook.title')"
                         :description="$t('signUp.errors.facebook.content')"/>
      <UniSectionMessage v-if="emailAlreadyExists" type="warning" :title="$t('signUp.errors.email.title')"
                         :description="$t('signUp.errors.email.content')"/>

      <primary-button v-if="!showMessage" type="submit" :clicked="clicked"
                      @click.native="valid? clicked = true: clicked = false"
                      class="mb-5">{{ $t('signUp.action') }}
      </primary-button>

    </validation-observer>
    <separator class="mb-5"/>
    <div class="grid gap-3 grid-cols-3 mb-28" v-if="!showMessage">
      <google-button :is-small="true" @click.native="signInWithGoogle"></google-button>
      <facebook-button :is-small="true" @click.native="signInWithFacebook"></facebook-button>
      <united-schools-button :is-small="true" @click.native="unitedSchoolsModal = true"></united-schools-button>
    </div>
    <p class="sign-in text-align-center">{{ $t('signUp.alreadyAccount') }}
      <router-link class="underline" :to="{name: 'Login'}">{{ $t('signUp.alreadyAccountAction') }}</router-link>
    </p>

    <uni-modal :title="$t('signUp.howItWorks')" :is-visible="openModal" @close-modal="openModal = false"
               :has-footer-slot="false">
      <template slot="body">
        <div class="container-embed" v-html="video"></div>
        <div style="var(--transition-quick)"
             class=" flex flex-col items-end arrow-full-screen">
          <svg width="92" height="76" viewBox="0 0 92 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M66.7417 27.5052L68.2279 27.7081L68.2279 27.7081L66.7417 27.5052ZM66.9255 26.1587L68.4118 26.3617L68.4173 26.321L68.4206 26.2801L66.9255 26.1587ZM65.8223 8.28689L64.3535 8.59121L64.3535 8.59121L65.8223 8.28689ZM66.0263 4.04391C65.3339 3.58915 64.4039 3.78184 63.9491 4.47429L56.5384 15.7584C56.0837 16.4509 56.2764 17.3809 56.9688 17.8356C57.6613 18.2904 58.5913 18.0977 59.046 17.4052L65.6333 7.37491L75.6637 13.9622C76.3561 14.417 77.2861 14.2243 77.7409 13.5318C78.1956 12.8394 78.0029 11.9094 77.3105 11.4546L66.0263 4.04391ZM62.0709 45.2208L60.6742 44.6739L60.6742 44.6739L62.0709 45.2208ZM63.6165 41.2734L65.0133 41.8203L65.0304 41.7766L65.0447 41.7319L63.6165 41.2734ZM48.0627 62.4522L47.2942 61.164L47.2942 61.164L48.0627 62.4522ZM48.3323 62.2913L49.1007 63.5795L49.1889 63.527L49.269 63.4629L48.3323 62.2913ZM51.1703 60.0223L50.2336 58.8507L50.2336 58.8507L51.1703 60.0223ZM23.9644 70.2489L24.1911 71.7316L24.1911 71.7316L23.9644 70.2489ZM31.7926 68.7302L31.4484 67.2702L31.4484 67.2702L31.7926 68.7302ZM34.3055 68.1378L34.6496 69.5978L34.6602 69.5953L34.6707 69.5927L34.3055 68.1378ZM58.6726 51.7895L57.4193 50.9654L57.4193 50.9654L58.6726 51.7895ZM68.2279 27.7081L68.4118 26.3617L65.4393 25.9558L65.2555 27.3022L68.2279 27.7081ZM67.2911 7.98256L66.6717 4.99338L63.7341 5.60203L64.3535 8.59121L67.2911 7.98256ZM63.4677 45.7677L65.0133 41.8203L62.2198 40.7265L60.6742 44.6739L63.4677 45.7677ZM48.8311 63.7404L49.1007 63.5795L47.5639 61.0031L47.2942 61.164L48.8311 63.7404ZM49.269 63.4629L52.107 61.1939L50.2336 58.8507L47.3956 61.1197L49.269 63.4629ZM16.6149 72.89L24.1911 71.7316L23.7377 68.7661L16.1615 69.9245L16.6149 72.89ZM32.1367 70.1902L34.6496 69.5978L33.9613 66.6779L31.4484 67.2702L32.1367 70.1902ZM24.1911 71.7316C26.8596 71.3236 29.5093 70.8095 32.1367 70.1902L31.4484 67.2702C28.8986 67.8713 26.3272 68.3701 23.7377 68.7661L24.1911 71.7316ZM47.2942 61.164C43.1356 63.6446 38.6367 65.5039 33.9402 66.683L34.6707 69.5927C39.6508 68.3424 44.4214 66.3708 48.8311 63.7404L47.2942 61.164ZM57.4193 50.9654C55.4534 53.9551 53.0284 56.6163 50.2336 58.8507L52.107 61.1939C55.1481 58.7625 57.7868 55.8669 59.9259 52.6136L57.4193 50.9654ZM68.4206 26.2801C68.9175 20.1583 68.5372 13.9968 67.2911 7.98256L64.3535 8.59121C65.5416 14.3256 65.9043 20.2004 65.4305 26.0374L68.4206 26.2801ZM59.9259 52.6136C61.3414 50.461 62.5284 48.1666 63.4677 45.7677L60.6742 44.6739C59.811 46.8785 58.7201 48.9871 57.4193 50.9654L59.9259 52.6136ZM65.0447 41.7319C66.5129 37.1591 67.578 32.4666 68.2279 27.7081L65.2555 27.3022C64.6293 31.8872 63.603 36.4087 62.1883 40.8148L65.0447 41.7319Z"
                fill="black"/>
          </svg>
          <p class="small italic">{{ $t('capsule.solutionVideo.helpParent') }}</p>
        </div>
      </template>
    </uni-modal>

    <uni-modal :title="$t('signIn.unitedSchools.login')"
               :is-visible="unitedSchoolsModal" @close-modal="unitedSchoolsModal = false; usMessage = null; usUser.username = ''; usUser.password = ''">
      <template v-slot:body>
        <validation-observer tag="form" ref="usForm" v-slot="{valid}" @submit.prevent="signinWithUnitedSchools">
          <uni-input
              :label="$t('signIn.unitedSchools.username')"
              id="input-test"
              type="text"
              v-model="usUser.username"
              rules="required"
          />
          <uni-input-password
              :label="$t('signIn.unitedSchools.password')"
              id="input-connexion-password"
              v-model="usUser.password"
              rules="required"/>
          <UniSectionMessage v-if="usMessage" type="error" :title="$t('signIn.errors.unitedSchools.title')"
                             :description="usMessage"/>

          <primary-button type="submit" class="subtle">
            <img height="24" width="24" src="../../assets/img/logo-US.png">&nbsp
            {{ $t('signIn.action') }}
          </primary-button>
        </validation-observer>
      </template>
    </uni-modal>

  </div>
</template>

<script>
import UniInput from "@/components/UniInput";
import UniInputPassword from "@/components/Password/UniInputPassword.vue";
import PrimaryButton from "@/components/PrimaryButton";
import Separator from "@/components/Separator";
import GoogleButton from "@/components/GoogleButton";
import FacebookButton from "@/components/FacebookButton";
import {mapActions, mapGetters} from "vuex";
import UniSectionMessage from "../../components/UniSectionMessage";
import LocaleSwitcherOnRight from "./LocaleSwitcherOnRight";
import UniModal from "@/components/UniModal";
import UniCheckbox from "@/components/UniCheckbox";
import UnitedSchoolsButton from "@/components/UnitedSchoolsButton.vue";
import i18n from "@/locales";

export default {
  name: "SignIn",
  data() {
    return {
      teacher: false,
      email: "",
      pwd: "",
      pwdConfirm: "",
      clicked: false,
      message: "",
      showMessage: false,
      openModal: false,
      video: '',

      googleAlreadyExists: false, // Si le compte google est déja enreistré dans notre base
      facebookAlreadyExists: false, // Si le compte Facebook est déja enreistré dans notre base
      googleNotExists: false, // Si le compte google n'est pas enregistré dans la BDD
      facebookNotExists: false, // SI le compte Facebook n'est pas enregistré dans la BDD
      badCredentials: false, // Si les identifiants de connexion sont incorrects
      emailAlreadyExists: false, // Si un compte avec la même adresse email existe déja

      unitedSchoolsModal: false,
      usUser: {
        username: "",
        password: ""
      },
      usMessage: null
    }
  },
  computed: {
    ...mapGetters({
      currentFamily: 'currentFamily'
    })
  },
  components: {
    UniCheckbox,
    UniModal,
    LocaleSwitcherOnRight,
    UniSectionMessage, FacebookButton, GoogleButton, Separator, PrimaryButton, UniInputPassword, UniInput,
    UnitedSchoolsButton
  },

  methods: {
    loginSuccessful(req) {
      localStorage.token = req.data.auth_token
      this.$store.dispatch('login')
      this.$nextTick(() => {
        this.$router.push({name: 'Families'})
      })
    },
    handleForm() {
      this.$refs.formInput.validate()
          .then(resp => {
            if (resp) {
              this.clicked = true
              this.$http.post('/families', {
                family: {
                  email: this.email,
                  password: this.pwd,
                  teacher: this.teacher
                }
              }).then((resp) => {
                if (resp.data) {
                  this.$router.push({name: 'SignInEmail'})
                  this.clicked = false
                }
              })
            } else {
              // TODO: error message bus
              // this.$refs.formInput.reset()
            }
          })
    },
    async signInWithGoogle() {
      const googleUser = await this.$gAuth.signIn()

      if (googleUser.getBasicProfile()) {

        let infos = googleUser.getBasicProfile()
        let family = {
          name: infos.getFamilyName(),
          firstname: infos.getGivenName(),
          google_id: googleUser.getId(),
          email: infos.getEmail(),
          avatar: infos.getImageUrl(),
          with_google: true
        }
        this.$http.post('/families', {family})
            .then((res) => {
              if (res.data.auth_token) {
                this.loginSuccessful(res)
              } else {
                if (res.data.code === 401) {
                  this.googleAlreadyExists = true

                  window.setTimeout(() => {
                    this.googleAlreadyExists = false
                  }, 5000)
                } else if (res.data.code === 402) {
                  this.emailAlreadyExists = true

                  window.setTimeout(() => {
                    this.emailAlreadyExists = false
                  }, 5000)
                }
              }

            })
            .catch(error => {
              if (this.$isSignatureExpired(error.response.data.message)) {
                this.$store.dispatch('logout')
                this.$router.push({name: 'furnitures', params: {q: 'expired'}})
              }
            })
      }
    },
    signInWithFacebook() {
      FB.login((response) => {
        if (response.status === 'connected') {
          FB.api('/me', {fields: 'last_name,first_name,email'}, (response) => {
            let family = {
              name: response.last_name,
              firstname: response.first_name,
              facebook_id: response.id,
              email: response.email,
              with_facebook: true
            }
            this.$http.post('/families', {family})
                .then((res) => {
                  if (res.data.auth_token) {
                    this.loginSuccessful(res)
                  } else {
                    if (res.data.code === 401) {
                      this.facebookAlreadyExists = true

                      window.setTimeout(() => {
                        this.facebookAlreadyExists = false
                      }, 5000)
                    } else if (res.data.code === 402) {
                      this.emailAlreadyExists = true

                      window.setTimeout(() => {
                        this.emailAlreadyExists = false
                      }, 5000)
                    }
                  }

                })
                .catch(error => {
                  if (this.$isSignatureExpired(error.response.data.message)) {
                    this.$store.dispatch('logout')
                    this.$router.push({name: 'furnitures', params: {q: 'expired'}})
                  }
                })
          })
        }
      }, {scope: 'public_profile,email'})
    },
    signinWithUnitedSchools() {
      this.$refs.usForm.validate().then(success => {
        if (success) {
          this.$http.post('/united_schools/signin', this.usUser)
              .then((result) => {
                if (result.status === 200 && !result.data.code && result.data.auth_token) {
                  this.loginSuccessful(result)
                } else {
                  switch (result.data.code) {
                    case 1:
                      this.usMessage = i18n.t('signIn.errors.unitedSchools.unknown')
                      break;
                    case 2:
                      this.usMessage = i18n.t('signIn.errors.unitedSchools.badCredentials')
                      break;
                    case 3:
                      this.usMessage = i18n.t('signIn.errors.unitedSchools.emailTaken')
                      break;
                    case 4:
                      this.usMessage = i18n.t('signIn.errors.unitedSchools.idTaken')
                      break;
                    default:
                      this.usMessage = i18n.t('signIn.errors.unitedSchools.title')
                      break;
                  }
                }
              })
        }
      })
    },
    isAllowed() {
      return this.currentFamily
    },
    /**
     * function qui permet d'init l'iframe via l'api youtube
     * @params array {Array} - array qui comprend les infos des vidéos youtube, id de la vidéo et nom de l'id html
     */
    initYoutube(array) {
      let _ = this
      window.onYouTubePlayerAPIReady = function () {
        array.forEach(el => {
          return new YT.Player(el.idFrame, {
            videoId: el.idVid,
            events: {
              onReady: _.onPlayerReady,
              onStateChange: _.onPlayerStateChange
            }
          });
        })


      }


    }
    ,
    /**
     * function qui permet de pause les vidéos youtube lorsqu'on clique sur un autre step
     * @params evt {}  player
     */
    onPlayerReady(evt) {
      // let btn = this.$refs["primary-btn"]
      // let backButton = this.$refs.iframeChild1.$refs.backButton
      // let backButton2 = this.$refs.iframeChild2.$refs.backButton
      // backButton.addEventListener('click', (e) => {
      //   e.preventDefault()
      //   evt.target.pauseVideo()
      // })
      // backButton2.addEventListener('click', (e) => {
      //   e.preventDefault()
      //   evt.target.pauseVideo()
      // })
      //
      // btn.$el.addEventListener('click', (e) => {
      //   e.preventDefault()
      //   evt.target.pauseVideo()
      // })


    },
    getId(url) {
      if (url.includes('shorts')) {
        let arr = url.split('/')
        let id = arr[arr.length - 1]
        return (id.length === 11)
            ? id
            : null;
      } else {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
      }

    }
  },
  updated() {
    this.checkCacheVersion()
    if (this.isAllowed()) {
      this.$router.push({name: 'Home'})
    }
  },
  mounted() {
    fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(ret => {
          this.$http.post('/stats/upv', {
            unique_page_view: {
              ip_address: ret.ip,
              url: window.location.pathname
            }
          })
        })
  },
  created() {
    this.checkCacheVersion()
    if (this.isAllowed()) {
      this.$router.push({name: 'Home'})
    }
    const videoId = this.getId("https://www.youtube.com/shorts/-1t3klAi_Vo");
    this.video = '<iframe allowfullscreen="allowfullscreen" src="//www.youtube.com/embed/'
        + videoId + '?rel=0;picture-in-picture=1&amp;accelerometer=1&amp;gyroscope=1&amp;autoplay=0" frameborder="0" style="border-radius: var(--radius-default);\n' +
        '    position: absolute;\n' +
        '    top: 0;\n' +
        '    bottom: 0;\n' +
        '    left: 0;\n' +
        '    width: 100%;\n' +
        '    height: 100%;\n' +
        '    border: 0;" ></iframe>'
  }

}
</script>

<style scoped>
.container-embed {
  border-radius: var(--radius-default);
  position: relative;
  width: 100%;
  height: 215px;
}

</style>
